import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Gavel, Clock, Users, ArrowRight } from "lucide-react";

function timeRemaining(endsAt) {
  const ms = new Date(endsAt) - new Date();
  if (ms <= 0) return "Terminée";
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  if (d > 0) return `${d}j ${h}h`;
  if (h > 0) return `${h}h ${m}min`;
  return `${m}min`;
}

export default function Auctions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    const load = () => api.get("/auctions").then(r => { if (!cancel) setItems(r.data); }).catch(()=>{}).finally(() => !cancel && setLoading(false));
    load();
    const id = setInterval(load, 30000);
    return () => { cancel = true; clearInterval(id); };
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-6 lg:py-10 fade-in has-bottom-nav" data-testid="auctions-page">
      <div className="bg-black text-white p-6 lg:p-10 mb-8 border-2 border-black">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-[color:var(--color-mint)] text-black flex items-center justify-center"><Gavel size={20} strokeWidth={2.5}/></div>
          <p className="label text-[color:var(--color-mint)]">Enchères Fripri</p>
        </div>
        <h1 className="text-4xl lg:text-6xl font-black tracking-tighter mb-3">Misez. Gagnez. Stylez.</h1>
        <p className="text-white/80 max-w-xl">Des articles uniques mis aux enchères par leurs propriétaires. Pas de prix fixe, juste le marché qui parle.</p>
      </div>

      {loading ? <p className="text-center py-10">Chargement…</p> :
        items.length === 0 ? (
          <div className="text-center py-20 border-2 border-dashed border-black">
            <Gavel size={32} strokeWidth={2} className="mx-auto mb-3"/>
            <p className="text-2xl font-black mb-2">Aucune enchère en cours</p>
            <p className="text-sm text-[color:var(--color-text-muted)]">Soyez le premier à proposer un article aux enchères !</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
            {items.map(a => (
              <Link key={a.auction_id} to={`/encheres/${a.auction_id}`} className="block border-2 border-black bg-white card-hover" data-testid={`auction-card-${a.auction_id}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[color:var(--color-surface)] relative">
                  {a.product?.images?.[0] ? (
                    <img src={fileUrl(a.product.images[0])} className="w-full h-full object-cover" alt={a.product?.title || ""}/>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-[color:var(--color-text-muted)] text-xs" data-testid={`auction-no-image-${a.auction_id}`}>
                      Pas d'image
                    </div>
                  )}
                  <span className="absolute top-2 left-2 pill pill-coral flex items-center gap-1"><Clock size={10}/> {timeRemaining(a.ends_at)}</span>
                </div>
                <div className="p-3">
                  <p className="label">{a.product?.brand || "—"}</p>
                  <h3 className="font-bold truncate">{a.product?.title}</h3>
                  <div className="flex items-end justify-between mt-2">
                    <div>
                      <p className="label">Offre actuelle</p>
                      <p className="display-num font-black text-xl" style={{color:"var(--color-coral)"}}>{a.current_price?.toFixed(0)}€</p>
                    </div>
                    <div className="text-right">
                      <p className="text-xs flex items-center gap-1 justify-end"><Users size={12}/> {a.bid_count}</p>
                      <p className="label">enchère{a.bid_count > 1 ? "s" : ""}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )
      }
    </div>
  );
}
